module.exports = __webpack_public_path__ + "img/index-s2.9aa12936.png";